export default __webpack_public_path__ + "static/media/Assignments.1f0f8e1e.svg";